import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { api, guestTokens, apiErrorMessage } from "@/api/client";
import { track } from "@/api/analytics";

const GuestAuthCtx = createContext(null);

export function GuestAuthProvider({ children }) {
  const [tokens, setTokens] = useState(() => guestTokens.read());

  const unlock = useCallback(async (apartmentId, password) => {
    try {
      const { data } = await api.post("/guest/unlock", { apartment_id: apartmentId, password });
      guestTokens.set(apartmentId, data.token);
      setTokens(guestTokens.read());
      track("view_apartment", { target_type: "apartment", target_id: apartmentId });
      return { ok: true };
    } catch (e) {
      track("click_unlock_attempt", { target_type: "apartment", target_id: apartmentId, meta: { fail: true } });
      return { ok: false, error: apiErrorMessage(e) };
    }
  }, []);

  const logout = useCallback((apartmentId) => {
    guestTokens.clear(apartmentId);
    setTokens(guestTokens.read());
  }, []);

  const isUnlocked = useCallback((apartmentId) => Boolean(tokens[apartmentId]), [tokens]);

  const value = useMemo(() => ({ tokens, unlock, logout, isUnlocked }), [tokens, unlock, logout, isUnlocked]);

  return <GuestAuthCtx.Provider value={value}>{children}</GuestAuthCtx.Provider>;
}

export const useGuestAuth = () => useContext(GuestAuthCtx);
